import { render } from "./lzc.vue?vue&type=template&id=037a6492&scoped=true"
import script from "./lzc.vue?vue&type=script&lang=js"
export * from "./lzc.vue?vue&type=script&lang=js"

import "./lzc.vue?vue&type=style&index=0&id=037a6492&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037a6492"]])

export default __exports__